import { ProfileForm } from "components/ProfileForm";
import React from "react";

export const RegisterProfileView = () => {
  return <ProfileForm />;
};
